import { c as _c } from "react/compiler-runtime";
import { useTranslation } from 'react-i18next';
import { HeaderTitle, NavigationHeader } from '@/idv/components';
import type { CameraErrorCause } from '../../types';
type CameraErrorProps = {
  onBack: () => void;
  cause: CameraErrorCause;
};
const CameraError = t0 => {
  const $ = _c(16);
  const {
    onBack,
    cause
  } = t0;
  let t1;
  if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
    t1 = {
      keyPrefix: "document-flow.components.media-errors"
    };
    $[0] = t1;
  } else {
    t1 = $[0];
  }
  const {
    t
  } = useTranslation("idv", t1);
  let t2;
  if ($[1] !== onBack) {
    t2 = <NavigationHeader leftButton={{
      variant: "back",
      onBack
    }} />;
    $[1] = onBack;
    $[2] = t2;
  } else {
    t2 = $[2];
  }
  let t3;
  if ($[3] !== t) {
    t3 = t(_temp);
    $[3] = t;
    $[4] = t3;
  } else {
    t3 = $[4];
  }
  let t4;
  if ($[5] !== cause) {
    t4 = $_0 => $_0[cause];
    $[5] = cause;
    $[6] = t4;
  } else {
    t4 = $[6];
  }
  let t5;
  if ($[7] !== t || $[8] !== t4) {
    t5 = t(t4);
    $[7] = t;
    $[8] = t4;
    $[9] = t5;
  } else {
    t5 = $[9];
  }
  let t6;
  if ($[10] !== t3 || $[11] !== t5) {
    t6 = <HeaderTitle title={t3} subtitle={t5} />;
    $[10] = t3;
    $[11] = t5;
    $[12] = t6;
  } else {
    t6 = $[12];
  }
  let t7;
  if ($[13] !== t2 || $[14] !== t6) {
    t7 = <div>{t2}{t6}</div>;
    $[13] = t2;
    $[14] = t6;
    $[15] = t7;
  } else {
    t7 = $[15];
  }
  return t7;
};
export default CameraError;
function _temp($) {
  return $.title;
}